import { Cell, Grid } from 'bold-ui'
import { useAcompanhamentoPreNatalQuery, useAcompanhamentoPuerperioMedicoesQuery } from 'graphql/hooks.generated'
import { AtendimentoProfissional, Medicao, TipoAcompanhamentoEnum } from 'graphql/types.generated'
import {
  getMedicaoForImcReferencia,
  getMedicoesAntropometricasPreNatalSorted,
} from 'view/atendimentos/detail/components/modals/medicoes/pre-natal/util-medicoesPreNatal'

import { AcompanhamentoCard } from '../../components/AcompanhamentoCard'
import { AcompanhamentoIconLabel } from '../../components/AcompanhamentoIconLabel'
import { formatGanhoPeso, formatMedicaoDefault } from '../../pre-natal/formatter-acompanhamentoPreNatal'
import { MedicaoField } from '../../pre-natal/model-acompanhamentoPreNatal'
import { convertToUltimasMedicoesRegistradas, getMedicoesPreNatal } from '../../pre-natal/util-acompanhamentoPreNatal'

interface MedicoesPuerperioCardProps {
  prontuarioId: ID
  dataInicioGestacao: Date
}

export function MedicoesPuerperioCard(props: Readonly<MedicoesPuerperioCardProps>) {
  const { prontuarioId, dataInicioGestacao } = props

  const {
    data: { medicoes },
    loading: loadingMedicoes,
  } = useAcompanhamentoPuerperioMedicoesQuery({
    variables: { prontuarioId },
    fetchPolicy: 'cache-first',
  })

  const {
    data: { atendimentosProfUltimaGestacao },
    loading: loadingAtendimentos,
  } = useAcompanhamentoPreNatalQuery({
    variables: {
      input: prontuarioId,
      onlyProblemaAtivo: false,
    },
    skip: !prontuarioId,
  })

  const medicoesAntropometricasPreNatal = getMedicoesAntropometricasPreNatalSorted(medicoes)
  const medicoesPreNatal = getMedicoesPreNatal(atendimentosProfUltimaGestacao as AtendimentoProfissional[])
  const medicaoForImcReferencia = getMedicaoForImcReferencia(dataInicioGestacao, medicoesAntropometricasPreNatal)

  const ultimasMedicoes = convertToUltimasMedicoesRegistradas(medicoesPreNatal, medicoes as Medicao[])
  const ultimaMedicaoPesoPreNatal: MedicaoField<number> = {
    medicao: medicoesPreNatal?.last()?.peso,
    dataMedicao: medicoesPreNatal?.last()?.dataDaMedicao,
  }

  return (
    <AcompanhamentoCard
      id='medicoes-puerperio'
      title='Medições do puerpério'
      tipoAcompanhamento={TipoAcompanhamentoEnum.PUERPERIO}
      loading={loadingMedicoes || loadingAtendimentos}
      placeholder='Nenhuma medição registrada'
      justifyHeaderContent='space-between'
      bodyPadding='1rem'
    >
      {ultimasMedicoes && (
        <Grid gap={0}>
          <Cell size={4}>
            <AcompanhamentoIconLabel
              icon='balanceFilled'
              iconText='Peso'
              childrenText={formatMedicaoDefault(ultimasMedicoes.peso, 'kg')}
            />
          </Cell>
          <Cell size={4}>
            <AcompanhamentoIconLabel
              icon='balancePlus'
              iconText='Ganho de peso no pré-natal'
              childrenText={formatGanhoPeso(dataInicioGestacao, ultimaMedicaoPesoPreNatal, medicaoForImcReferencia)}
            />
          </Cell>
          <Cell size={4}>
            <AcompanhamentoIconLabel
              icon='bloodPressureFilled'
              iconText='Pressão arterial'
              childrenText={formatMedicaoDefault(ultimasMedicoes.pressaoArterial, 'mmHg')}
            />
          </Cell>
        </Grid>
      )}
    </AcompanhamentoCard>
  )
}
